import { useEffect, useState } from 'react';
import { FeaturesApi } from 'src/api';
import { getMilestoneUpsellVariant, MilestoneUpsellVariant } from './getMilestoneUpsellVariant';
import { MilestoneType } from './milestoneUpsellStorage';

/** MEME web experiments are stored as `web_<slug>`. */
export const MILESTONE_UPSELL_EXPERIMENT = 'web_milestone_identity_upsell';

const parseVariant = (alternative?: string): MilestoneUpsellVariant | null => {
  const match = alternative?.match(/^(?:variant\s+)?([abc])$/i);
  return match ? (match[1].toUpperCase() as MilestoneUpsellVariant) : null;
};

export const useMilestoneUpsellVariant = (
  userId: number | null | undefined,
  milestone: MilestoneType,
  override?: MilestoneUpsellVariant,
) => {
  const [variant, setVariant] = useState<MilestoneUpsellVariant | null>(override ?? null);

  useEffect(() => {
    if (override) {
      setVariant(override);
      return;
    }

    let isCurrent = true;
    const fallback = getMilestoneUpsellVariant(milestone);

    if (!userId) {
      setVariant(fallback);
      return;
    }

    void FeaturesApi.featuresPost({
      context: { uid: String(userId) },
      experiments: [MILESTONE_UPSELL_EXPERIMENT],
      features: {},
    })
      .then(response => {
        if (isCurrent) {
          setVariant(parseVariant(response.experiments[MILESTONE_UPSELL_EXPERIMENT]) ?? fallback);
        }
      })
      .catch(() => {
        if (isCurrent) {
          setVariant(fallback);
        }
      });

    return () => {
      isCurrent = false;
    };
  }, [milestone, override, userId]);

  return variant;
};
